import { getValidJwtToken } from "../auth/authSession";
import { getApiBaseUrl } from "../auth/apiBase";

export const POS_RENDER_ERROR_EVENT = "xentros-pos-render-error";

export type POSClientErrorInput = {
  kind: "window_error" | "unhandled_rejection" | "render_error";
  message: string;
  stackTrace?: string | null;
  context?: Record<string, unknown>;
};

export async function reportPosClientError(hotelId: string, input: POSClientErrorInput) {
  const token = getValidJwtToken();
  if (!hotelId || !token) return false;
  const clientEventId = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/hotels/${encodeURIComponent(hotelId)}/pos/error-events/client`,
      {
        method: "POST",
        keepalive: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          clientEventId,
          kind: input.kind,
          message: input.message.slice(0, 2_000),
          stackTrace: input.stackTrace?.slice(0, 12_000) ?? null,
          route: `${window.location.pathname}${window.location.search}`.slice(0, 500),
          occurredAt: new Date().toISOString(),
          correlationId: clientEventId,
          context: {
            userAgent: navigator.userAgent,
            viewport: { width: window.innerWidth, height: window.innerHeight },
            ...input.context,
          },
        }),
      },
    );
    return response.ok;
  } catch {
    // Error reporting must never create another unhandled application error.
    return false;
  }
}
